// NOTE: This file was copied directly from mozio-web
import { useTranslation } from "react-i18next";
import { useCurrency } from "../hooks";

export const removePrefix = (value: string, prefix: string) => {
  if (value.startsWith(prefix)) {
    return value.slice(prefix.length);
  }
  return value;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type Processor = (...args: any[]) => string;

type Processors = {
  [key: string]: Processor;
};

export const PROCESSORS: Processors = {
  DOMAIN_WO_PREFIX: (...prefixes: string[]) => {
    const str = window.location.hostname;
    for (const prefix of prefixes) {
      if (str.startsWith(prefix)) {
        return removePrefix(str, prefix);
      }
    }
    return str;
  },
  DOMAIN: (removeLevels = "0") => {
    const str = window.location.hostname;
    const parts = str.split(".").slice(Number.parseInt(removeLevels, 10));
    return parts.join(".");
  },
  CURRENCY: () => {
    const { currency } = useCurrency();
    return currency || "USD";
  },
  LANGUAGE: () => {
    const {
      i18n: { language },
    } = useTranslation();
    return language || "en_US";
  },
  IF_LANG: (lang: string, value: string) => {
    const {
      i18n: { language },
    } = useTranslation();
    const activeLang = language || "en_US";
    return activeLang === lang ? value : "";
  },
  IF_DOMAIN: (domain: string, value: string) => {
    const activeDomain = window.location.hostname;
    return activeDomain === domain ? value : "";
  },
};

/**
 * Replace variables in given string and return the result. It try to find
 * processor by name, and if it not exists it will try to find config variable.
 * Otherwise it will just keep pattern there.
 **/

export const formatString = (tpl = "", vars = {}) => {
  return (
    tpl &&
    tpl.replaceAll &&
    tpl.replaceAll(/{([^}]+)}/g, (match, val) => {
      const argsSeparator = val.indexOf(":");
      const parts =
        argsSeparator > 0
          ? [
              val.slice(0, Math.max(0, argsSeparator)),
              val.slice(argsSeparator + 1),
            ]
          : [val];

      if (PROCESSORS[parts[0]]) {
        const args = parts.length > 1 ? parts[1].split(",") : [];
        if (typeof PROCESSORS[parts[0]] === "function") {
          const processor = PROCESSORS[parts[0]] as Processor;
          return processor(...args);
        } else {
          return "";
        }
      } else if (vars && Object.prototype.hasOwnProperty.call(vars, parts[0])) {
        return vars[parts[0] as keyof typeof vars];
      }

      return match || "";
    })
  );
};
